import { keyBy, difference, isEmpty } from 'lodash';

export const sortOfferMechanicPresetsByPriority = (presets, priorityOrder) => {
    if (isEmpty(priorityOrder)) {
        return presets;
    }

    const presetsByKey = keyBy(presets, 'offerTemplate');
    const allKeys = presets.map(p => p.offerTemplate);
    const remainingKeys = difference(allKeys, priorityOrder);

    // Prioritised keys that exist, followed by remaining keys
    const sortedKeys = [...priorityOrder.filter(key => presetsByKey[key]), ...remainingKeys];

    return sortedKeys.map(key => presetsByKey[key]);
};

export default { sortOfferMechanicPresetsByPriority };
